import { type FC } from 'react';
import {
  UiStack,
  uiStyles,
  UiText,
  UiBox,
  type UiStackProps,
  UiHStack,
  UiIconPencilSimple
} from '@/lib/ui';

export interface FieldInputProps extends UiStackProps {
  label: string
  type: string
  onClick: () => void
  isRequired?: boolean
}

const FieldInput: FC<FieldInputProps> = ({
  label,
  onClick,
  isRequired = false,
  ...props
}) => {
  return (
    <UiStack
      borderRadius={uiStyles.borderRadius}
      spacing={2}
      onClick={onClick}
      {...uiStyles.hover}
      {...props}
    >
      <UiHStack justifyContent={'space-between'}>
        <UiText color={'text.secondary'}>{label}{isRequired ? ' *' : ''}</UiText>
        {/* <UiIconPencilSimple size={'2xl'} color={'primary.400'}/> */}
      </UiHStack>
      <UiBox
        height={'40px'}
        // width={'320px'}
        borderRadius={uiStyles.formElementBorderRadius}
        borderWidth={'1px'}
        borderStyle={'solid'}
        borderColor={'gray.400'}
        bgColor={'indigo.50'}
      />
    </UiStack>
  );
};

export default FieldInput;
